<template>

  <div>
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <Panel class="panel panel-default panel-border-color panel-border-color-primary">
            <PageHeader title="Settings" subtitle="Configure how you study">
            </PageHeader>

            <div class="sm-p-30 xs-pt-30 xs-pb-30 xs-pl-10 xs-pr-10">
              <div class="row">
                <div class="col-sm-12 col-md-6">

                  <div class="setting form-group row form-group-sm">
                    <label class="col-xs-6 col-form-label" for="OrderMicronotesBy">Order micro notes by</label>
                    <div class="col-xs-6">
                      <select class="form-control" id="OrderMicronotesBy" v-model="selectedMicroNoteOrder">
                        <option v-for="option in microNoteOrderOptions" v-bind:value="option.value">
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="setting form-group row form-group-sm">
                    <label class="col-xs-6 col-form-label" for="AllowSharing">Allow sharing</label>
                    <div class="col-xs-6">
                      <div class="pull-left">
                        <BoolSwitch :toggle-bool="AllowSharing" :toggle-function="toggleSharing" on-text="On" off-text="Off"></BoolSwitch>
                      </div>
                    </div>
                  </div>
                  <div class="setting form-group row form-group-sm">
                    <label class="col-xs-6 col-form-label" for="AllowSharing">Receive system notifications</label>
                    <div class="col-xs-6">
                      <div class="pull-left">
                        <BoolSwitch class="pull-left" :toggle-bool="notifications" :toggle-function="toggleNotifications" on-text="On" off-text="Off"></BoolSwitch>
                        <div class="clearfix"></div>
                        <div class="text-danger xs-mt-10" v-if="!notifications">Warning: You will not receive any system emails (shared lecture notes, blog comments, etc.)</div>
                      </div>
                    </div>
                  </div>

                </div><!-- /.col -->
              </div><!-- /.row -->
              <div class="row">
                <div class="col-xs-12 col-md-6 text-right">
                  <button class="btn btn-primary btn-lg" v-on:click="saveSettings">Save</button>
                </div>
              </div>
            </div><!-- /.main-content -->
          </Panel>
        </div><!-- /div -->
      </div><!-- /div -->
    </div><!-- /div -->
  </div><!-- /div -->

</template>

<script>

  import { mapState, mapActions, mapGetters } from 'vuex';
  import BoolSwitch from '../shared/controls/BoolSwitch'

export default {
  components: {
    BoolSwitch,
  },

    created() {
      if (this.currentUser.studySort && this.currentUser.sortOrder) {
        this.selectedMicroNoteOrder = this.currentUser.studySort + '|' + this.currentUser.sortOrder;
      }
      if (this.currentUser.AllowSharing !== undefined) {
        this.AllowSharing = this.currentUser.AllowSharing;
      }
      if (this.currentUser.notifications !== undefined) {
        this.notifications = this.currentUser.notifications;
      }
  },

  methods: {
    saveSettings: function (event) {
      let microNoteOrder = this.selectedMicroNoteOrder.split('|');

      this.$store.dispatch('updateUser', {
        changes: {
          studySort: microNoteOrder[0],
          sortOrder: microNoteOrder[1],
          AllowSharing: this.AllowSharing,
          notifications: this.notifications,
        },
        callback: (err) => {
          Toast.success('Settings updated successfully');
        },
      })
    },

    toggleSharing(value) {
      this.AllowSharing = value;
    },

    toggleNotifications(value) {
      this.notifications = value;
    }
  },

  computed: {
    ...mapState([
      'currentUser',
    ])
    },

  data() {
    return {
      selectedMicroNoteOrder: 'created_at|ASC',
      AllowSharing: true,
      notifications: true,
      microNoteOrderOptions: [
        { label: 'Creation date, ascending', value: 'created_at|ASC' },
        { label: 'Creation date, descending', value: 'created_at|DESC' },
        { label: 'Next study date, ascending', value: 'next_study_at|ASC' },
        { label: 'Next study date, descending', value: 'next_study_at|DESC' }
      ]
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .settings-container {padding:30px;}
</style>



// WEBPACK FOOTER //
// settings.vue?7dfc53cc